import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ICON_TYPE } from "utils/constants";
import { getAllEvents } from "./api";
import "./style.scss";
import { NotificationConnection } from "utils/notificationHub";
import { TabBar } from "components/Tabbar/Tabbar";
import { TabEventNotification } from "./components/TabEventNotification";
import { Toast } from "components/ToastShow/ToastAlert";
import { trans } from "utils/helpers";
import { MessageType } from "types/enum";
import { Message } from "components/Message/Message";

export const EventNotification = () => {
  const [response, setResponse] = useState<any>(null);
  let content = [
    {
      title: "OrganizationalEvent",
      disable: false,
      key: "CalendarOrganizationalEvents",
      icon: (
        <div className="position-relative">
          <FontAwesomeIcon
            icon={[ICON_TYPE, "calendar-days"]}
            style={{ width: "15px", height: "15px" }}
          />
          {!!response?.CalendarOrganizationalEvents?.length && (
            <span
              className="position-absolute translate-middle bg-warning border border-light rounded-circle"
              style={{ top: "1px", left: "-6px", padding: "3px" }}
            ></span>
          )}
        </div>
      ),
      body: (
        <TabEventNotification
          onHide={() => handleClose()}
          data={response?.CalendarOrganizationalEvents}
        />
      ),
    },

    {
      title: "PersonReminders",
      disable: false,
      key: "PersonReminders",
      icon: (
        <div className="position-relative">
          <FontAwesomeIcon
            icon={[ICON_TYPE, "bell"]}
            style={{ width: "15px", height: "15px" }}
          />
          {!!response?.PersonReminders?.length && (
            <span
              className="position-absolute translate-middle bg-warning border border-light rounded-circle"
              style={{ top: "1px", left: "-6px", padding: "3px" }}
            ></span>
          )}
        </div>
      ),
      body: (
        <TabEventNotification
          onHide={() => handleClose()}
          data={response?.PersonReminders}
        />
      ),
    },

    {
      title: "PersonalEvent",
      disable: false,
      key: "CalendarPersonalEvents",
      icon: (
        <div className="position-relative">
          <FontAwesomeIcon
            icon={[ICON_TYPE, "user"]}
            style={{ width: "15px", height: "15px" }}
          />
          {!!response?.CalendarPersonalEvents?.length && (
            <span
              className="position-absolute translate-middle bg-warning border border-light rounded-circle"
              style={{ top: "1px", left: "-6px", padding: "3px" }}
            ></span>
          )}
        </div>
      ),

      body: (
        <TabEventNotification
          onHide={() => handleClose()}
          data={response?.CalendarPersonalEvents}
        />
      ),
    },
    {
      title: "CalendarEvents",
      disable: false,
      key: "CalendarEvents",

      icon: (
        <div className="position-relative">
          <FontAwesomeIcon
            icon={[ICON_TYPE, "list-check"]}
            style={{ width: "15px", height: "15px" }}
          />
          {!!response?.CalendarEvents.length && (
            <span
              className="position-absolute translate-middle bg-warning border border-light rounded-circle"
              style={{ top: "1px", left: "-6px", padding: "3px" }}
            ></span>
          )}
        </div>
      ),

      body: (
        <TabEventNotification
          onHide={() => handleClose()}
          data={response?.CalendarEvents}
        />
      ),
    },
  ];
  const [showList, setShowList] = useState<boolean>(false);
  const [NotificationConnectionState, setNotificationConnectionState] =
    useState<any>(null);
  const [curentTab, setCurentTab] = useState<any>("personalEvent");
  const [responseContent, setResponseContent] = useState<any>(content);

  const handleClose = () => {
    localStorage.setItem(
      "showEventNotif",
      JSON.stringify({
        length:
          response?.PersonReminders.length +
          response?.CalendarEvents.length +
          response?.CalendarOrganizationalEvents.length +
          response?.CalendarPersonalEvents.length,
        show: false,
      })
    );
    setShowList(false);
  };

  const getAllEventsAsync = async () => {
    try {
      const res = await getAllEvents();
      setResponse(res.Data);
    } catch (error) {}
  };

  useEffect(() => {
    getAllEventsAsync();
    setNotificationConnectionState(NotificationConnection);
  }, []);

  useEffect(() => {
    if (response) {
      content.map((item) => {
        if (response[item.key] == undefined || response[item.key].length == 0) {
          item.disable = true;
        } else {
          setCurentTab(item.title);
        }
      });
      setResponseContent(content);
    }
  }, [response]);

  useEffect(() => {
    if (NotificationConnectionState) {
      NotificationConnectionState.on("NewEvent", (text) => {
        if (text != "BulletinBoard") {
          getAllEventsAsync();
        }
      });
    }
  }, [NotificationConnectionState]);

  const tabChangeHandle = (tab) => {
    setCurentTab(tab);
  };

  const handleNotif = (e) => {
    e.preventDefault();
    if (
      [
        ...response?.PersonReminders,
        ...response?.CalendarEvents,
        ...response?.CalendarOrganizationalEvents,
        ...response.CalendarPersonalEvents,
      ].length <= 0
    ) {
      Toast(trans("msg_notfound"), MessageType.warning);
      // Toast(trans("msg_notfound"), "warning")
    } else {
      setShowList(true);
    }
  };

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("showEventNotif") as string)?.length !=
        response?.PersonReminders.length +
          response?.CalendarEvents.length +
          response?.CalendarOrganizationalEvents.length +
          response?.CalendarPersonalEvents.length &&
      response &&
      [
        ...response?.PersonReminders,
        ...response?.CalendarEvents,
        ...response?.CalendarOrganizationalEvents,
        ...response.CalendarPersonalEvents,
      ].length > 0
    ) {
      localStorage.setItem(
        "showEventNotif",
        JSON.stringify({
          length:
            response?.PersonReminders.length +
            response?.CalendarEvents.length +
            response?.CalendarOrganizationalEvents.length +
            response?.CalendarPersonalEvents.length,
          show: true,
        })
      );
    }
  }, [
    response?.PersonReminders?.length,
    response?.CalendarEvents?.length,
    response?.CalendarOrganizationalEvents?.length,
    response?.CalendarPersonalEvents?.length,
  ]);

  return (
    <>
      {response ? (
        JSON.parse(localStorage.getItem("showEventNotif") as string)?.show &&
        [
          ...response?.PersonReminders,
          ...response?.CalendarEvents,
          ...response?.CalendarOrganizationalEvents,
          ...response.CalendarPersonalEvents,
        ].length > 0 && (
          <li className="header-itemsIcons">
            <button className="Event-btn" onFocus={() => setShowList(true)}>
              {
                <a
                  className="position-relative"
                  onClick={(e) => {
                    handleNotif(e);
                  }}
                >
                  <FontAwesomeIcon icon={[ICON_TYPE, "calendar-days"]} />
                  {response &&
                  [
                    ...response?.PersonReminders,
                    ...response?.CalendarEvents,
                    ...response?.CalendarOrganizationalEvents,
                    ...response.CalendarPersonalEvents,
                  ].length > 0 ? (
                    <span className="badgeCartable">
                      {response?.PersonReminders.length +
                        response?.CalendarEvents.length +
                        response?.CalendarOrganizationalEvents.length +
                        response?.CalendarPersonalEvents.length}
                    </span>
                  ) : (
                    <></>
                  )}
                </a>
              }
              {showList &&
                response &&
                [
                  ...response?.PersonReminders,
                  ...response?.CalendarEvents,
                  ...response?.CalendarOrganizationalEvents,
                  ...response.CalendarPersonalEvents,
                ].length > 0 && (
                  <>
                    <div className="fullscreen-bg-modal" />
                    <section className="Event-menu ">
                      <TabBar
                        showWithIcon={true}
                        addDisable={false}
                        tabChange={tabChangeHandle}
                        content={responseContent}
                        curentTab={curentTab}
                        defaultTab={"personalEvent"}
                      />
                    </section>
                  </>
                )}
            </button>
          </li>
        )
      ) : (
        <></>
      )}
    </>
  );
};
